module.exports = __webpack_public_path__ + "img/image (12).97b74d42.jpg";